<template>
  <div>
    <profile-card v-if="showProfile"></profile-card>
    <header v-if="$route.path === '/risk-status'" class="risk-plan-header-title">
      <h1>{{ getOrganizationName(defaultOrganization) }} COVID-19 Response Plan</h1>
    </header>
    <header v-else class="risk-plan-header-title no-margin">
      <h1>{{ getOrganizationName(defaultOrganization) }} COVID-19 Response Plan</h1>
    </header>
    <template v-if="isPdfOnly && isPdfPresent && pdfUrl">
      <a :href="pdfUrl" target="_blank" class="btn btn-primary">
        Open Full Screen
      </a>
      <iframe id="risk-response-plan-iframe" :src="pdfUrl" frameborder="0"/>
    </template>
    <template v-else>
      <div v-if="$route.path === '/risk-status'" class="cont">
        <div v-if="this.publishedRiskResponsePlan" class="risk-level-container">
          <header class="risk-plan-header">
            <h4 class="risk-level-title">{{
                $t('riskStatus.communityRiskLevelTitle', {riskLevel: this.currentRiskStatus.attributes.name['en-US']})
              }}</h4>
            <p class="risk-level-date">{{ $t('riskStatus.lastUpdatedDate', {datetime: this.riskLevelLastUpdated}) }}</p>
          </header>
          <div class="separator"></div>
          <h5 class="tab-header">{{ $t('riskStatus.tab2Title') }}</h5>
          <div class="separator"></div>
          <div class="tab-container"
              v-html="this.renderMitigationPlanTab('tab2', this.currentRiskStatus.attributes.name['en-US'].toLowerCase())"/>
          <div class="separator"></div>
          <h5 class="tab-header">{{ $t('riskStatus.tab3Title') }}</h5>
          <div class="separator"></div>
          <div class="tab-container"
              v-html="this.renderMitigationPlanTab('tab3', this.currentRiskStatus.attributes.name['en-US'].toLowerCase())"/>
          <div class="separator"></div>
          <h5 class="tab-header">{{ $t('riskStatus.tab4Title') }}</h5>
          <div class="separator"></div>
          <div class="tab-container"
              v-html="this.renderMitigationPlanTab('tab4', this.currentRiskStatus.attributes.name['en-US'].toLowerCase())"/>
          <div class="separator"></div>
          <h5 class="tab-header">{{ $t('riskStatus.tab5Title') }}</h5>
          <div class="separator"></div>
          <div class="tab-container"
              v-html="this.renderMitigationPlanTab('tab5', this.currentRiskStatus.attributes.name['en-US'].toLowerCase())"/>
        </div>
      </div>
      <div v-else class="cont">
        <div v-if="this.publishedRiskResponsePlan" class="risk-level-container">
          <header class="risk-plan-header">
            <h4 class="risk-level-title">{{ $t('riskStatus.communityRiskLevelTitleHigh') }}</h4>
            <p class="risk-level-date">{{ $t('riskStatus.lastUpdatedDate', {datetime: this.riskLevelLastUpdated}) }}</p>
          </header>
          <div class="separator"></div>
          <h5 class="tab-header">{{ $t('riskStatus.tab2Title') }}</h5>
          <div class="separator"></div>
          <div class="tab-container" v-html="this.renderMitigationPlanTab('tab2', 'high')"/>
          <div class="separator"></div>
          <h5 class="tab-header">{{ $t('riskStatus.tab3Title') }}</h5>
          <div class="separator"></div>
          <div class="tab-container" v-html="this.renderMitigationPlanTab('tab3', 'high')"/>
          <div class="separator"></div>
          <h5 class="tab-header">{{ $t('riskStatus.tab4Title') }}</h5>
          <div class="separator"></div>
          <div class="tab-container" v-html="this.renderMitigationPlanTab('tab4', 'high')"/>
          <div class="separator"></div>
          <h5 class="tab-header">{{ $t('riskStatus.tab5Title') }}</h5>
          <div class="separator"></div>
          <div class="tab-container" v-html="this.renderMitigationPlanTab('tab5', 'high')"/>
        </div>

        <div v-if="this.publishedRiskResponsePlan" class="risk-level-container">
          <header class="risk-plan-header">
            <h4 class="risk-level-title">{{ $t('riskStatus.communityRiskLevelTitleMedium') }}</h4>
            <p class="risk-level-date">{{ $t('riskStatus.lastUpdatedDate', {datetime: this.riskLevelLastUpdated}) }}</p>
          </header>
          <div class="separator"></div>
          <h5 class="tab-header">{{ $t('riskStatus.tab2Title') }}</h5>
          <div class="separator"></div>
          <div class="tab-container" v-html="this.renderMitigationPlanTab('tab2', 'medium')"/>
          <div class="separator"></div>
          <h5 class="tab-header">{{ $t('riskStatus.tab3Title') }}</h5>
          <div class="separator"></div>
          <div class="tab-container" v-html="this.renderMitigationPlanTab('tab3', 'medium')"/>
          <div class="separator"></div>
          <h5 class="tab-header">{{ $t('riskStatus.tab4Title') }}</h5>
          <div class="separator"></div>
          <div class="tab-container" v-html="this.renderMitigationPlanTab('tab4', 'medium')"/>
          <div class="separator"></div>
          <h5 class="tab-header">{{ $t('riskStatus.tab5Title') }}</h5>
          <div class="separator"></div>
          <div class="tab-container" v-html="this.renderMitigationPlanTab('tab5', 'medium')"/>
        </div>

        <div v-if="this.publishedRiskResponsePlan" class="risk-level-container">
          <header class="risk-plan-header">
            <h4 class="risk-level-title">{{ $t('riskStatus.communityRiskLevelTitleLow') }}</h4>
            <p class="risk-level-date">{{ $t('riskStatus.lastUpdatedDate', {datetime: this.riskLevelLastUpdated}) }}</p>
          </header>
          <div class="separator"></div>
          <h5 class="tab-header">{{ $t('riskStatus.tab2Title') }}</h5>
          <div class="separator"></div>
          <div class="tab-container" v-html="this.renderMitigationPlanTab('tab2', 'low')"/>
          <div class="separator"></div>
          <h5 class="tab-header">{{ $t('riskStatus.tab3Title') }}</h5>
          <div class="separator"></div>
          <div class="tab-container" v-html="this.renderMitigationPlanTab('tab3', 'low')"/>
          <div class="separator"></div>
          <h5 class="tab-header">{{ $t('riskStatus.tab4Title') }}</h5>
          <div class="separator"></div>
          <div class="tab-container" v-html="this.renderMitigationPlanTab('tab4', 'low')"/>
          <div class="separator"></div>
          <h5 class="tab-header">{{ $t('riskStatus.tab5Title') }}</h5>
          <div class="separator"></div>
          <div class="tab-container" v-html="this.renderMitigationPlanTab('tab5', 'low')"/>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {format} from 'date-fns';
import {mapState} from 'vuex';
import OrganizationService from '@/services/organization.service';
import common from '@/mixins/common';

export default {
  name: 'RiskStatusPage',
  mixins: [common],
  props: {
    showProfile: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      publishedRiskResponsePlan: null,
      isPdfOnly: false,
      isPdfPresent: false,
      pdfUrl: null,
    };
  },
  components: {
    ProfileCard: () => import('@/components/profile-card/profile-card.vue'),
  },
  created() {
    this.initialLoad();
  },
  computed: {
    ...mapState(['currentUser', 'currentMember', 'defaultOrganization', 'currentRiskStatus', 'currentRiskStatusReference']),
    riskLevelLastUpdated() {
      let updatedAt = '';
      if (this.currentRiskStatusReference && this.currentRiskStatusReference.meta) {
        updatedAt = format(new Date(this.currentRiskStatusReference.meta.updated_at), 'yyyy/MM/dd - h:mm a');
      }
      this.log('RiskStatus -> riskLastUpdatedAt', 'updatedAt', updatedAt);
      return updatedAt;
    },
  },
  methods: {
    reset() {
      this.publishedRiskResponsePlan = null;
      this.isPdfOnly = false;
      this.isPdfPresent = false;
      this.pdfUrl = null;
    },
    initialLoad() {
      this.reset();
      const organizationId = this.defaultOrganization.data.id;
      OrganizationService.publishedRiskResponsePlan(organizationId).then(({data}) => {
        if (data && data.attributes) {
          // assign result to published risk response plan
          this.publishedRiskResponsePlan = data;
          let blogType = data.attributes.blog_type;
          if (blogType === 'Risk Response PDF') {
            this.log('RiskStatus -> initialLoad', 'blogType', blogType);
            this.log('RiskStatus -> initialLoad', 'dam_asset', data.attributes.dam_asset);
            this.isPdfOnly = true;
            this.log('RiskStatus -> initialLoad', 'isPdfOnly', this.isPdfOnly);
            if (data.attributes.dam_asset) {
              this.isPdfPresent = true;
              this.pdfUrl = data.attributes.dam_asset.url;
              this.log('RiskStatus -> initialLoad', 'isPdfPresent', this.isPdfPresent);
              this.log('RiskStatus -> initialLoad', 'pdfUrl', this.pdfUrl);
            }
          }
        }
      });
    },
    renderMitigationPlanTab(jsonName, riskToRender = 'low') {
      let htmlResponse = '';
      const fullRiskLabel = `${riskToRender}Risk`;
      this.publishedRiskResponsePlan.attributes.body[jsonName]['en-us'].slides
        .map((slide) => slide.questions[0])
        .forEach((question) => {
          if (question.published) {
            if (question.oneAnswer) {
              htmlResponse += `
              <p class="risk-content-question m-0 mb-1 p-0"><strong>${question.question}</strong></p>
              <div class="risk-content-answer m-0 p-0">${question.answer}</div>`;
            } else {
              htmlResponse += `
              <p class="risk-content-question m-0 mb-1 p-0"><strong>${question.question}</strong></p>
              <div class="risk-content-answer m-0 p-0">${question[fullRiskLabel]}</div>`;
            }
          }
        });
      return htmlResponse;
    },
  },
};
</script>

<style lang="scss" scoped src="./styles.scss">
</style>
